/**
 * @enum {number}
 * MeasurementVolume classification type.
 */
const VolumeClassificationType = {
  /**
   * @type {number}
   * @constant
   */
  TERRAIN: 0,
  /**
   * @type {number}
   * @constant
   */
  BOTH: 1,
};

export default Object.freeze(VolumeClassificationType);
